import { mainAPI, handleApiError } from "../api";
import {
  HelpRequest,
  CreateHelpRequest,
  UpdateHelpRequest,
  DeleteHelpsRequest,
  HelpResponse,
} from "../types/api/help";

const path = `/faq/admin/${process.env.REACT_APP_API_VERSION}/questions`;

// Вопросы - Получить список
export function fetchHelps(params: HelpRequest) {
  return mainAPI
    .get<HelpResponse[]>(`${path}`, {
      params,
    })
    .then(
      (res) => {
        const countHeader = res.headers["count"];
        return Promise.resolve({
          list: res.data,
          totalCount: countHeader,
        });
      },
      (error) => handleApiError(error)
    );
}

// Вопросы - Создать
export function createHelp(data: CreateHelpRequest) {
  return mainAPI.post(`${path}`, data).then(
    (res) => {
      return Promise.resolve(res.data as HelpResponse);
    },
    (error) => handleApiError(error)
  );
}

// Вопросы - Изменить
export function updateHelp(faqId: string, data: UpdateHelpRequest) {
  return mainAPI.put(`${path}/${faqId}`, data).then(
    (res) => {
      return Promise.resolve(res.data as HelpResponse);
    },
    (error) => handleApiError(error)
  );
}

// Вопросы - Удалить
export function deleteHelps(data: DeleteHelpsRequest) {
  return mainAPI.post(`${path}/delete`, data).then(
    (res) => {
      return Promise.resolve(res.data);
    },
    (error) => handleApiError(error)
  );
}
